

const catalogPath = [
  'M36.1666 29.1667H20.6666M25.8333',
  '39.5H20.6666M41.3333',
  '18.8333H20.6666M51.6666',
  '18.3167V45.1833C51.6666 49.5237',
  '51.6666 51.6939 50.8219',
  '53.3518C50.0789 54.81 48.8933',
  '55.9956 47.4351',
  '56.7386C45.7773 57.5833 43.6071',
  '57.5833 39.2666',
  '57.5833H22.7333C18.3929 57.5833',
  '16.2227 57.5833 14.5649',
  '56.7386C13.1066 55.9956 11.921',
  '54.81 11.178',
  '53.3518C10.3333 51.6939 10.3333',
  '49.5237 10.3333',
  '45.1833V18.3167C10.3333 13.9763',
  '10.3333 11.8061 11.178',
  '10.1482C11.921 8.68998 13.1066',
  '7.50438 14.5649',
  '6.76136C16.2227 5.91666 18.3929',
  '5.91666 22.7333',
  '5.91666H39.2666C43.6071 5.91666',
  '45.7773 5.91666 47.4351',
  '6.76136C48.8933 7.50438 50.0789',
  '8.68998 50.8219',
  '10.1482C51.6666 11.8061 51.6666',
  '13.9763 51.6666 18.3167Z',
].join(' ');

const FlatPriceCatalog = (_props: Record<string, unknown>) => (
  <svg
    width="62"
    height="63"
    viewBox="0 0 62 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={catalogPath}
      stroke="#3E7CFF"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default FlatPriceCatalog;
